import { Button, LinearProgress } from "@mui/joy";
import { BASE_URL, BLACK, PRIMARY } from "../../appConstants";
import { useEffect, useState } from "react";
import axios from "axios";
import appError from "../../appError";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { updateBrandData } from "../../redux/appDataSlice";



const Crawl = () => {
    const brandId = useSelector((state: any) => state.appData.brand_id);
    const stage = useSelector((state: any) => state.appData.stage);
    const dispatch = useDispatch();



    const onStartCrawlingClickHandler = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.get(`${BASE_URL}onboarding/startCrawl?brand_id=${brandId}`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const { message, brand: {brand_id ,stage,onboarding_type } } = res.data.data;
            toast.success(message);
            dispatch(updateBrandData({brand_id, stage,onboarding_type }));
        } catch (error) {
            appError(error);
        } finally {

        }
    }

    return (
        <div className="flex justify-center items-center h-full" >
            {
                stage === "ONBOARDING" && (
                    <div className="flex flex-col justify-center items-center" >
                        <div className="mb-4" style={{ fontSize: 18, fontWeight: 400, color: BLACK.B_80 }}> If you have completed all the previous steps then you can click on Start Crawling button.</div>
                        <Button
                            sx={{
                                backgroundColor: PRIMARY.P_BLue,
                                ":disabled": {
                                    backgroundColor: PRIMARY.P_Blue,
                                    color: BLACK.B_10,
                                }
                            }}
                            onClick={onStartCrawlingClickHandler}
                        >Start Crawling</Button>
                    </div>
                )
            }

            {
                stage === "CRAWLING" && (
                    <div>
                        <div className="mb-10" style={{ fontSize: 18, fontWeight: 400, color: BLACK.B_80 }}>This progress will be continue in background, you can close this window!</div>
                        <LinearProgress
                            sx={{
                                height: "16px"
                            }}
                            determinate value={25}
                        />
                        <div className="flex items-center justify-center mt-8" >
                            <div style={{ backgroundColor: PRIMARY.P_Purple, borderRadius: 8 }} className="flex justify-center items-center h-6 w-6 mr-1" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                    <path d="M10.9998 3.76269C10.9115 3.80841 10.8087 3.8172 10.7139 3.78714C10.6192 3.75708 10.5402 3.69062 10.4945 3.60238C10.1365 2.89527 9.59472 2.29762 8.92601 1.87223C8.88434 1.84594 8.84825 1.8117 8.81981 1.77147C8.79137 1.73124 8.77113 1.6858 8.76024 1.63775C8.74936 1.58969 8.74805 1.53996 8.75639 1.4914C8.76472 1.44284 8.78254 1.3964 8.80883 1.35473C8.83511 1.31305 8.86935 1.27696 8.90958 1.24852C8.94981 1.22008 8.99525 1.19984 9.04331 1.18895C9.09136 1.17807 9.14109 1.17676 9.18965 1.1851C9.23821 1.19343 9.28465 1.21125 9.32633 1.23754C10.1057 1.73654 10.7385 2.43358 11.1601 3.25738C11.2058 3.34566 11.2146 3.44847 11.1845 3.54322C11.1545 3.63798 11.088 3.71692 10.9998 3.76269ZM2.17367 3.80488C2.24237 3.80485 2.30975 3.78595 2.36844 3.75024C2.42713 3.71453 2.47488 3.66338 2.50648 3.60238C2.86442 2.89527 3.40621 2.29762 4.07492 1.87223C4.15909 1.81914 4.21872 1.7348 4.24069 1.63775C4.26267 1.5407 4.24519 1.43889 4.19211 1.35473C4.13902 1.27056 4.05468 1.21093 3.95763 1.18895C3.86058 1.16698 3.75877 1.18445 3.67461 1.23754C2.89527 1.73654 2.26244 2.43358 1.84086 3.25738C1.81125 3.31453 1.79685 3.37834 1.79905 3.44267C1.80124 3.50699 1.81995 3.56967 1.85339 3.62467C1.88682 3.67967 1.93385 3.72514 1.98994 3.7567C2.04603 3.78826 2.10931 3.80485 2.17367 3.80488ZM10.8971 8.67707C10.9635 8.791 10.9988 8.92043 10.9992 9.05231C10.9997 9.18419 10.9653 9.31386 10.8997 9.42824C10.834 9.54262 10.7394 9.63766 10.6253 9.70379C10.5112 9.76992 10.3816 9.80479 10.2498 9.80488H8.33726C8.2512 10.2287 8.02124 10.6098 7.68636 10.8835C7.35148 11.1572 6.93227 11.3068 6.49976 11.3068C6.06726 11.3068 5.64805 11.1572 5.31317 10.8835C4.97829 10.6098 4.74833 10.2287 4.66227 9.80488H2.74976C2.61796 9.80462 2.48856 9.76963 2.37458 9.70344C2.26061 9.63724 2.16609 9.54218 2.10055 9.42783C2.035 9.31348 2.00076 9.18387 2.00125 9.05207C2.00174 8.92027 2.03696 8.79093 2.10336 8.67707C2.5257 7.94816 2.74976 6.91176 2.74976 5.67988C2.74976 4.68532 3.14485 3.73149 3.84811 3.02823C4.55138 2.32497 5.5052 1.92988 6.49976 1.92988C7.49433 1.92988 8.44815 2.32497 9.15142 3.02823C9.85468 3.73149 10.2498 4.68532 10.2498 5.67988C10.2498 6.91129 10.4738 7.94769 10.8971 8.67707ZM7.56008 9.80488H5.43945C5.51714 10.024 5.6608 10.2136 5.85067 10.3478C6.04054 10.4819 6.2673 10.5539 6.49976 10.5539C6.73223 10.5539 6.95899 10.4819 7.14886 10.3478C7.33873 10.2136 7.48239 10.024 7.56008 9.80488ZM10.2498 9.05488C9.75101 8.19848 9.49976 7.06316 9.49976 5.67988C9.49976 4.88423 9.18369 4.12117 8.62109 3.55856C8.05848 2.99595 7.29541 2.67988 6.49976 2.67988C5.70412 2.67988 4.94105 2.99595 4.37844 3.55856C3.81584 4.12117 3.49976 4.88423 3.49976 5.67988C3.49976 7.06363 3.24758 8.19894 2.74976 9.05488H10.2498Z" fill="#1C1C1C" />
                                </svg>
                            </div>
                            <div style={{ fontSize: 14, fontWeight: 400, color: BLACK.B_40 }} >
                                We’ll notify you when the crawl is complete via Alerts.
                            </div>

                        </div>
                    </div>
                )
            }


        </div>
    )
}

export default Crawl;